// TODO: transform gigs that are no longer live/active: set isExpired

export const transformAll = (unitsOfWork) => {
    // TODO: Take a unitsOfWorkType parameter, switch on it to select a transformer
    const gigs = unitsOfWork.map((unitOfWork) => {
        return unitOfWork
    })
    return gigs
}

export const transformCraigslistAds = (ads) => {
    const gigs = ads.map((ad, index) => {
        ad.bid_avg = null
        ad.bid_count = null
        ad.budget_minimum = null
        ad.budget_maximum = null
        ad.type = null
        ad.frontend_project_status = null
        ad.elements[0].elements[0].cdata
            ?
            ad.title = ad.elements[0].elements[0].cdata
            :
            ad.title = null
        ad.elements[2].elements
            ?
            ad.preview_description = ad.elements[2].elements[0].cdata
            :
            ad.preview_description = ""
        ad.time_submitted = ad.elements[3].elements[0].text //date
        ad.id = ad.elements[1].elements[0].text.slice(-15).substring(0, 10) //<-I know this should be regex, it's temporary
        ad.link = ad.elements[1].elements[0].text
        delete ad.attributes
        delete ad.elements
        return ad
    })
    return gigs
}

export const transformFreelancerProjects = (projects) => {
    const gigs = projects // TODO: Remove any unwanted properties
    return gigs
}

const mapDescription = desc => {
    if (desc) {
        desc = desc.substr(0, 253).concat('...')
    }
    return desc
}

export const transformGig = gig => ({
    bid_avg: null,
    bid_count: null,
    budget_minimum: gig.minimum,
    budget_maximum: gig.maximum,
    type: gig.type,
    status: gig.status,
    title: gig.title,
    preview_description: mapDescription(gig.description),
    time_submitted: new Date(gig.datePosted),
    id: gig.zaasId,
    seo_url: gig.url,
    publisher: gig.publisher,
    isSaved: gig.isSaved ? true : false,
    location: {
        full_address: gig.location && gig.location.length > 0 ? gig.location[0] : ''
    }
});


export const transformGFHGigs = gigs => {
    return gigs.map(transformGig)
}